import { useMap } from 'react-leaflet';
import { useInternalMetricsEnabled } from '../../store/featureStore';
import { fmt } from '../../utils/numberFormat';

/**
 * Developer aid: current map zoom level. Only rendered on dev deployments
 * (INTERNAL_METRICS_ENABLED) — for operators the number carries no meaning.
 */
export function ZoomDisplay() {
  const map = useMap();
  const internalMetrics = useInternalMetricsEnabled();
  if (!internalMetrics) return null;
  const zoom = map.getZoom();

  return (
    <div className="absolute bottom-4 right-4 bg-white dark:bg-primary-800 text-gray-900 dark:text-primary-100 border border-gray-300 dark:border-primary-600 px-2 py-1 rounded shadow-lg z-1000">
      Zoom: {fmt(zoom, 1)}
    </div>
  );
}
